import React, { useEffect, useState } from "react";
import type { MarketRecap } from "../../features/kquant/types";
import { mockApi } from "../../features/kquant/api/mockApi";
import { FormControlStyles } from "../../components/ui/FormControlStyles";
import { Background } from "../../features/kquant/components/Background";
import { Header } from "../../features/kquant/components/Header";
import { HeroSection } from "./HeroSection";
import { HotTopicsSection } from "./HotTopicsSection";
import { MarketAnalysisSection } from "./MarketAnalysisSection";
import { MarketRecapSection } from "./MarketRecapSection";
import { Toast, ToastState } from "../../features/kquant/components/Toast";
import { MapFilter, MarketTab } from "../../features/kquant/components/MarketHeatmapCard";

export default function KQuantSmartInsightsPage() {
  const [marketTab, setMarketTab] = useState<MarketTab>("Overview");
  const [mapFilter, setMapFilter] = useState<MapFilter>("S&P 500");
  const [recap, setRecap] = useState<MarketRecap | null>(null);

  const [query, setQuery] = useState("");
  const [toast, setToast] = useState<ToastState>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const rc = await mockApi.getMarketRecap();
        if (!alive) return;
        setRecap(rc.recap);
      } catch (e) {
        if (!alive) return;
        setToast({
          title: "Smart Insights",
          body: "初始化数据失败，请稍后重试。",
        });
        // eslint-disable-next-line no-console
        console.error(e);
      }
    })();
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function onAnalyze() {
    try {
      const res = await mockApi.analyzeQuery(query);
      setToast({ title: "Smart Insights", body: res.answer, followups: res.followups });
    } catch (e) {
      setToast({ title: "Smart Insights", body: "Analyze 失败，请稍后重试。" });
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#050514] text-white">
      <FormControlStyles />
      <Background />

      <div className="relative mx-auto max-w-[1280px] px-8">
        <Header />

        <main className="pb-16">
          <HeroSection query={query} setQuery={setQuery} onAnalyze={onAnalyze} />

          <HotTopicsSection />

          <MarketAnalysisSection
            marketTab={marketTab}
            setMarketTab={setMarketTab}
            mapFilter={mapFilter}
            setMapFilter={setMapFilter}
          />

          <MarketRecapSection recap={recap} />
        </main>
      </div>

      <Toast
        toast={toast}
        onClose={() => setToast(null)}
        onPickFollowup={(text) => {
          setQuery(text);
          setToast(null);
        }}
      />
    </div>
  );
}
